import React from "react";
import "../scss/index.scss";

export default function Loading() {
  return <div>Loading...</div>;
}
